import React, { useState } from "react";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";
import {
  createStyles,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import "jspdf-autotable";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import { CustomTheme } from "../../../../types/customTheme";
import DialogCommonDefault from "../../../../components/dialogs/DialogCommonDefault";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import { Autocomplete } from "@material-ui/lab";
import SwitchCommon from "../../../../components/switches/SwitchCommon";

const warningTypeList = [
  {
    id: "blink",
    label: "Blink",
  },
  {
    id: "text",
    label: "Text",
  },
  {
    id: "box",
    label: "Box",
  },
];

const criticalTypeList = [
  {
    id: "blink",
    label: "Blink",
  },
  {
    id: "text",
    label: "Text",
  },
  {
    id: "box",
    label: "Box",
  },
];

export interface DashboardCreateModalProps {
  open: any;
  setOpen: any;
  selectedWarningType: any;
  setSelectedWarningType: any;
  selectedCriticalType: any;
  setSelectedCriticalType: any;
  configDetails: any;
  setIsDarkMode: any;
  isDarkMode: any;
}

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    autoComplete: {
      marginTop: "4px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_background,
        borderRadius: 10,
      },
      [`& fieldset`]: {
        borderRadius: 10,
        border: "none",
        color: theme.palette.custom.orange.contrastText,
      },
    },
  }),
);

const ConfigDetailsModal: React.FunctionComponent<
  DashboardCreateModalProps
> = ({
  open,
  setOpen,
  selectedWarningType,
  setSelectedWarningType,
  selectedCriticalType,
  setSelectedCriticalType,
  configDetails,
  setIsDarkMode,
  isDarkMode,
}) => {
  const [isOpenWarningType, setIsOpenWarningType] = useState(false);
  const [isOpenCriticalType, setIsOpenCriticalType] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const match: any = useRouteMatch();
  const locationId = match?.params?.locationId;

  const handleChangeWarningType = (e: any, role: any) => {
    // Update the state with the selected role
    setSelectedWarningType(role);
  };

  const handleChangeCriticalType = (e: any, role: any) => {
    // Update the state with the selected role
    setSelectedCriticalType(role);
  };

  const handleActivate = () => {
    setIsDarkMode(!isDarkMode);
  };

  const classes: any = useStyles();

  return (
    <>
      <DialogCommonDefault
        open={open}
        setOpen={setOpen}
        maxWidth={"xs"}
        isNeedFixedHeight={false}
      >
        <DialogContent>
          <Typography variant="h5" style={{ marginBottom: "12px" }}>
            Configuration
          </Typography>

          <Typography variant="body1">Select Warning Type</Typography>
          <Autocomplete
            open={isOpenWarningType}
            onOpen={() => setIsOpenWarningType(true)}
            onClose={() => setIsOpenWarningType(false)}
            size={"small"}
            id="locationSelectGlobal"
            color="inherit"
            options={warningTypeList}
            value={selectedWarningType}
            getOptionLabel={(option: any) => option.label || ""}
            disableClearable
            onChange={handleChangeWarningType}
            classes={{ root: classes.autoComplete }}
            popupIcon={<ArrowDropDownIcon color={"inherit"} />}
            renderOption={(props: any) => {
              return (
                <Grid
                  container
                  {...props}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    zIndex: 0,
                    height: "20px",
                    marginBottom: "4px",
                  }}
                >
                  <Grid item xs={12}>
                    <Typography variant="body2" className={classes.titleColor}>
                      {props.label}
                    </Typography>
                  </Grid>
                </Grid>
              );
            }}
            renderInput={(params: any) => (
              <TextField
                color="inherit"
                {...params}
                label=""
                placeholder="Select Warning Type"
                variant="outlined"
              />
            )}
          />

          <Typography variant="body1" style={{ marginTop: "12px" }}>
            Select Critical Type
          </Typography>
          <Autocomplete
            open={isOpenCriticalType}
            onOpen={() => setIsOpenCriticalType(true)}
            onClose={() => setIsOpenCriticalType(false)}
            size={"small"}
            id="locationSelectGlobal"
            color="inherit"
            options={criticalTypeList}
            value={selectedCriticalType}
            getOptionLabel={(option: any) => option.label || ""}
            disableClearable
            onChange={handleChangeCriticalType}
            classes={{ root: classes.autoComplete }}
            popupIcon={<ArrowDropDownIcon color={"inherit"} />}
            renderOption={(props: any) => {
              return (
                <Grid
                  container
                  {...props}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    zIndex: 0,
                    height: "20px",
                    marginBottom: "4px",
                  }}
                >
                  <Grid item xs={12}>
                    <Typography variant="body2" className={classes.titleColor}>
                      {props.label}
                    </Typography>
                  </Grid>
                </Grid>
              );
            }}
            renderInput={(params: any) => (
              <TextField
                color="inherit"
                {...params}
                label=""
                placeholder="Select Warning Type"
                variant="outlined"
              />
            )}
          />
          <FormControlLabel
            style={{ marginRight: "0px", marginLeft: "0px", marginTop: "12px" }}
            control={<SwitchCommon />}
            checked={isDarkMode}
            onChange={handleActivate}
            label="Dark Mode"
            labelPlacement="start"
          />
        </DialogContent>
        <DialogActions style={{ marginBottom: "12px", marginRight: "12px" }}>
          <ButtonCommon
            style={{ width: "120px" }}
            onClick={() => {
              setOpen(false);
              setSelectedWarningType({});
            }}
          >
            Cancel
          </ButtonCommon>
          <ButtonCommon
            style={{ width: "120px" }}
            onClick={() => setOpen(false)}
            disabled={!selectedWarningType}
            isLoadingPage={isLoading}
            color="green"
          >
            Save
          </ButtonCommon>
        </DialogActions>
      </DialogCommonDefault>
      <DefaultAlert
        open={!!success}
        handleClose={() => setSuccess("")}
        message={success}
        severity={"success"}
      />

      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};

export default ConfigDetailsModal;
